import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from "~/components/utils/Accordion";
import PhonebookAppSettingsDownload from "~/reception/PhonebookAppSettingsDownload";

/** 電話帳・アプリ設定ダウンロードを設定画面のアコーディオンとして表示する */
const PhonebookAppSettingsDownloadSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: t("phonebookAppSettingsDownload"),
          content: <PhonebookAppSettingsDownload />,
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default PhonebookAppSettingsDownloadSection;
